import React, { useEffect, useMemo, useState } from 'react';
import {
  Card, Col, Form, Row,
} from 'react-bootstrap';
import { observer } from 'mobx-react';
import style from './style.module.less';
import HorizontalDivider from '../../../common/HorizontalDivider';
import FileInput from '../../../UI/upload/FileInput';
import { useStore } from '../../../../stores/StoreHelpers';
import TooltippedElement from '../../../common/TooltippedElement';
import CloseButtonComponent from '../../../CloseButtonComponent/CloseButtonComponent';
import ConfirmModal from '../../../common/ConfirmModal';
import StatusBadge from '../../../common/StatusBadge';
import { isStrategyTeam } from '../../../../services/rolesSvc';

const ArticleCard = observer(({
  showCardNotFound,
  value,
  onDeleteFile,
  updateResultObject,
  onChangeFile,
  onDeleteArticle,
  userCtx,
  stratId,
  can,
}) => {
  // const [file,setFile] = useState(value?.file ?? null)
  // const store = useStore()
  // useEffect(()=>{
  //     setFile(value?.file)
  // },[store.articles.resultObject])
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const authorsStr = useMemo(() => value?.authors?.map((x) => `${x?.lastName} ${x.firstName} ${x?.middleName ?? ''}`.trimRight()).join(', '), [value]);
  const teamAuthorsStr = useMemo(() => value?.teamMembers?.map((x) => `${x?.lastName} ${x.firstName} ${x?.middleName ?? ''}`.trimRight()).join(', '), [value]);
  const content = useMemo(() => (
    <div>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Ссылка на статью в БД</Col>
        <Col className="col-8"><a target="_blank" href={value?.linkNote} rel="noreferrer">{value?.linkNote}</a></Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Название статьи</Col>
        <Col className="col-8">{value?.articleName}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Название журнала</Col>
        <Col className="col-8">{value?.journalName}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Год учета статьи</Col>
        <Col className="col-8">{value?.year}</Col>
        {/*    //todo publish year */}
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Год публикации статьи</Col>
        <Col className="col-8">{value?.publishYear}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Номер тома</Col>
        <Col className="col-8">{value?.volume}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Номер выпуска журнала</Col>
        <Col className="col-8">{value?.issue}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Номера страниц</Col>
        <Col className="col-8">{value?.pp}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">ID Wos</Col>
        <Col className="col-8">{value?.wosId}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">ID Scopus</Col>
        <Col className="col-8">{value?.scopusId}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">DOI</Col>
        <Col className="col-8"><a target="_blank" href={value?.doi} rel="noreferrer">{value?.doi}</a></Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Id Pure</Col>
        <Col className="col-8">{value?.pureId ?? value?.id}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Импакт-фактор журнала</Col>
        <Col className="col-8">{value?.impact}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Квартиль журнала Wos</Col>
        <Col className="col-8">{value?.quartileWos}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Квартиль журнала Scopus</Col>
        <Col className="col-8">{value?.quartileScopus}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Авторы статьи</Col>
        <Col className="col-8">{authorsStr}</Col>
      </Row>
      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Авторы из команды</Col>
        <Col className="col-8">{teamAuthorsStr}</Col>
      </Row>

      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Сведения о финансировании</Col>
        <Col className="col-8">{value?.bibliographicNote}</Col>
      </Row>

      <Row className={`d-flex flex-row ${style.articleRow}`}>
        <Col className="col-4">Учесть публикацию в показатель</Col>
        <Col className="col-8">{value?.relatedPcs}</Col>
      </Row>
      <HorizontalDivider />
      <Row className={`d-flex flex-row ${style.articleAdditionalRow}`}>
        <Form.Group as={Col}>
          <Form.Check
            name="highlyCheck"
            disabled={!can.Edit}
            label="Высокоцитируемая публикация типов «Article» и «Review», индексируемая в базе данных WoS CC"
            checked={value?.highlyCitedPaper}
            onChange={(e) => {
              updateResultObject(!value.highlyCitedPaper, 'highlyCitedPaper');
            }}
            type="checkbox"
          />
        </Form.Group>
      </Row>
      <Row className={`d-flex flex-row ${style.articleAdditionalRow}`}>
        <Form.Group as={Col}>
          <Form.Check
            disabled={!can.Edit}
            style={{ display: 'contents' }}
            name="priorityCheck"
            checked={value?.isPriorityFinSource}
            onChange={(e) => {
              updateResultObject(!value.isPriorityFinSource, 'isPriorityFinSource');
            }}
            type="checkbox"
          />
          <TooltippedElement
            styledHelpIcon={{ marginBottom: '3px' }}
            iconSize="18px"
            tooltip="Допускается отмечать статьи, в которых отсутствует указание на какую-либо финансовую поддержку, при этом статья содержит результаты исследований по тематике, финансируемой за счет Приоритет 2030"
          >
            <span>
                                &nbsp; Статья содержит указание на финансовую поддержку исследований только за счёт средств программы Приоритет 2030
            </span>
          </TooltippedElement>
        </Form.Group>
      </Row>
      <Row className={`d-flex flex-row ${style.articleAdditionalRow}`}>
        <Form.Group as={Col}>
          <Form.Label>Подтверждающий результат документ</Form.Label>
          <FileInput
            disabled={!can.Edit}
            customState
            isSingle
            downloadble
            onDeleteFile={(id) => onDeleteFile(id)}
            fileList={value?.file && value.file}
            onFileChange={(newFiles) => {
              onChangeFile([...newFiles], 'file');
            }}
            className={style.fileInputResults}
          />
        </Form.Group>
      </Row>
    </div>
  ), [value]);

  return (
    <Row className={style.rowResult}>
      <Card>
        <Card.Body>
          <div className={style.articleBody}>
            <div style={{ marginBottom: '20px' }}><StatusBadge type="article" status={value?.status} /></div>
            <div className={style.articleHeader}>
              <span>Результаты поиска:</span>
            </div>
            {(showCardNotFound || value === null) ? <span>Статья не найдена.</span> : content}
          </div>
        </Card.Body>
      </Card>
    </Row>
  );
});

export default ArticleCard;
